// styles.ts
import styled from "styled-components";
import { Button, Input, Typography, Form as AntdFormItem } from "antd";

// Container for the login form
export const LoginWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 20px);
  background-color: #fff;
  flex-direction: column;
`;

// Styled form container
export const FormContainer = styled.div`
  background-color: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  text-align: center;
`;

// Styled Title for the form
export const FormTitle = styled(Typography.Title)`
  margin-bottom: 20px !important;
  font-weight: 700 !important;
  color: #333;
  text-align: left;
`;

// Styled Input fields
export const FormInput = styled(Input)`
  border-radius: 0.5rem;
  padding: 7px 11px;
`;

// Styled Button
export const SubmitButton = styled(Button)`
  width: 100%;
  background-color: #134076;
  border: none;
  height: 40px;
  font-size: 16px;
  border-radius: 0.5rem;

  &:hover {
    background-color: #134076e0;
  }
`;

// Forgot password link style
export const ForgotPasswordLink = styled.label`
  color: #134076;
  font-size: 14px;
  display: block;
  text-decoration: none;
  text-align: left;
  margin-bottom: 20px;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

export const FormItem = styled(AntdFormItem.Item)`
  align-items: center;
  .ant-form-item-explain-error {
    text-align: left;
  }
`;

export const InputLabel = styled.label`
  display: block;
  text-align: left;
  text-decoration: none;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;
